import { callApi } from '../service'

export const levelsService = {
    getAll
};

async function getAll() {
    return callApi('/BackOffice/levels', 'GET')
        .then((result) => {
            if (result.responseCode === "00") {
                return result.data;
            } else {
                return [];
            }
        });
}